import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { delayWhen, map, Observable, ReplaySubject, switchMap } from 'rxjs';
import { CiscoMigrationSite } from '../../../shared/models/generated/ziroModels';
import { MigrationsCucmNumberReportContext } from '../../services/cisco/migrations-cucm-number-report.context';

@Injectable()
export class MigrationsCiscoSiteManagementContext {
  private _http = inject(HttpClient);
  private _route = inject(ActivatedRoute);
  private _migrationsCucmNumberReportContext: MigrationsCucmNumberReportContext = inject(
    MigrationsCucmNumberReportContext,
  );

  private _stateSource = new ReplaySubject<CiscoMigrationSite[]>(1);
  state$ = this._stateSource.asObservable();

  private _baseUrl = `/services/microsoft/migrations/tenants/${this._route.snapshot.params.tenantId}/exports/cisco/${this._route.snapshot.params.id}/number-report/site-management/sites`;

  constructor() {
    this.refresh().subscribe();
  }

  refresh(): Observable<void> {
    return this._http.get<CiscoMigrationSite[]>(this._baseUrl).pipe(
      map((sites) => {
        this._stateSource.next(sites);
      }),
    );
  }

  save(sites: CiscoMigrationSite[]): Observable<void> {
    return this._http.put<CiscoMigrationSite[]>(this._baseUrl, sites).pipe(
      delayWhen(() => this._migrationsCucmNumberReportContext.softRefresh()),
      switchMap(() => this.refresh()),
    );
  }
}
